import React, { useContext, useEffect, useState } from "react";
import "./NoteMoveFolderModal.css";
import { useLanguage } from "../../../../LanguageProvider";
import { IoCloseOutline } from "react-icons/io5";
import { GeneralContext } from "../../../../GeneralProvider";
import { TbFolder } from "react-icons/tb";

export default function NoteMoveFolderModal({ onClose, onComplete }) {
    const { selectedNote, myNotes, handleMoveNoteFolder } = useContext(GeneralContext);
    const { getTranslation } = useLanguage();

    const [folderList, setFolderList] = useState([]);
    const [selectedFolder, setSelectedFolder] = useState(null); // Track selected folder

    useEffect(() => {
        let folders = myNotes.folders.map(folder => ({
            title: folder.title,
            folderId: folder.folderId
        }));
        if (selectedNote.folderId) {
            folders = folders.filter(x=>x.folderId !== selectedNote.folderId)
        }
        setFolderList(folders);
    }, [myNotes]);

    const handleFolderClick = (folderId) => {
        setSelectedFolder(folderId); // Update selected folder
    };

    const handleConfirm = () => {
        handleMoveNoteFolder(selectedNote.noteId, selectedFolder)
        onClose();
    };

    return (
        <div className="move-note-modal-overlay">
            <div className="move-note-modal-container">
                <IoCloseOutline
                    className="move-note-modal-button close"
                    onClick={onClose}
                />

                <p className="move-note-modal-title">{getTranslation("moveToFolder")}</p>

                <div className="move-note-folder-holder">
                    {folderList.map((folder) => (
                        <div
                            key={folder.folderId}
                            className={`move-note-folder ${selectedFolder === folder.folderId ? 'selected' : ''}`}
                            onClick={() => handleFolderClick(folder.folderId)}
                        >
                            <TbFolder strokeWidth={1} size={44} />
                            <span>{folder.title}</span>
                        </div>
                    ))}
                </div>

                <div className="move-note-modal-actions">
                    <button
                        className="move-note-modal-button create"
                        onClick={handleConfirm}
                        disabled={!selectedFolder} // Disable button if no folder is selected
                    >
                        {getTranslation("ok")}
                    </button>
                </div>
            </div>
        </div>
    );
}
